var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVilkas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 452.5 114.4",
    style: {
      enableBackground: "new 0 0 452.5 114.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F97CC;}\n\t.st1{fill:#1C3A63;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.1,23h19c1.1,0,2,0.9,2,2v86c0,1.1-0.9,2-2,2h-19c-1.1,0-2-0.9-2-2V25C111.1,23.8,112,23,113.1,23 C113.1,23,113.1,23,113.1,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.9,94V112c0,0.6-0.4,1-1,1h-49.6c-0.6,0-1-0.4-1-1V24c0-0.6,0.4-1,1-1h21c0.6,0,1,0.4,1,1v68 c0,0.6,0.4,1,1,1h26.6C207.5,93,207.9,93.4,207.9,94C207.9,94,207.9,94,207.9,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.5,74.8v35.9c0,1.3-1,2.3-2.3,2.3h-18.4c-1.3,0-2.3-1-2.3-2.3V25.2c0-1.3,1-2.3,2.3-2.3h18.4 c1.3,0,2.3,1,2.3,2.3v29.9l29-31.4c0.4-0.5,1-0.7,1.7-0.7h23c1.3,0,2.3,1,2.3,2.3c0,0.6-0.2,1.1-0.6,1.6L266.9,63 c-0.8,0.8-0.8,2.1-0.1,3l33.8,43.3c0.8,1,0.6,2.4-0.4,3.2c-0.4,0.3-0.9,0.5-1.4,0.5h-24.6c-0.7,0-1.4-0.3-1.8-0.9L244.5,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.3,1.2l-35.3,84L24.3,41.1c-0.3-0.7-1-1.1-1.8-1.1H2c-1.1,0-2,0.9-2,2c0,0.3,0.1,0.6,0.2,0.8l31.5,69 c0.3,0.7,1,1.2,1.8,1.2h23c0.8,0,1.5-0.5,1.8-1.2l46.9-109c0.4-1,0-2.2-1-2.6C104,0.1,103.7,0,103.4,0H82.1 C81.3,0,80.6,0.5,80.3,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.6,40H2c-1.1,0-2,0.9-2,2c0,0.3,0.1,0.6,0.2,0.8l31.5,69c0.3,0.6,0.8,1,1.5,1.1l11.8-27.7L24.4,41.1 C24,40.4,23.3,40,22.6,40z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.7,23l-27.5,88.6c-0.3,0.8-1,1.4-1.9,1.4h-21.5c-1.1,0-2-0.9-2-2c0-0.2,0-0.4,0.1-0.6l28-86 c0.3-0.8,1-1.4,1.9-1.4L357.7,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.6,23l27.5,88.5c0.3,0.8,1,1.4,1.9,1.4h21.5c1.1,0,2-0.9,2-2c0-0.2,0-0.4-0.1-0.6l-28-86 c-0.3-0.8-1-1.4-1.9-1.4L334.6,23z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.7,92l-3.5,15.8c-0.2,1,0.3,2,1.3,2.3c9,3,18.4,4.5,27.9,4.4c18.2,0,31.2-10.9,31.2-25 c0-17-6.9-23.2-17.6-27.8c-9.5-4-26-3.3-25.1-14.7c0.5-6,9.8-9,17-7.5c4.1,0.9,10.5,2,12.7,2.4c1,0.2,2-0.4,2.3-1.4l3.9-12.7 c0.3-1-0.2-2.1-1.2-2.5c-3.4-1.2-11.7-3.7-24.4-3.7c-16.6,0-29.5,10.6-29.5,26.6S400.3,71,411,73.6c11.5,2.9,23,3.7,20.8,14 c-1.8,8.9-11.8,7.8-18.2,6.6c-4.8-0.9-12-2.8-15.5-3.7C397,90.2,395.9,90.9,395.7,92C395.7,92,395.7,92,395.7,92z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVilkas);
export default __webpack_public_path__ + "static/media/vilkas.1afcc57e329c306e94ab457aecc328ee.svg";
export { ForwardRef as ReactComponent };